<template>
    <div v-if="show">
        <div
            class="mega-menu-item"
            @click="reset"
        >
            <span
                class="menu-item text-color-brand"
                v-text="'<'"
            />
            <span
                class="menu-item text-color-brand"
                v-html="'Tilbage'"
            />
        </div>
        <div
            v-for="(singleLink, i) in list.Links"
            :key="i"
            class="mega-menu-item"
        >
            <a
                :href="singleLink.Url"
                :alt="singleLink.Alt"
                class="mega-menu-link menu-item"
                v-html="singleLink.Text"
            />
        </div>
        <div
            v-if="link"
            class="mega-menu-item"
        >
            <a
                :href="link.Url"
                :alt="link.Alt"
                class="mega-menu-link menu-item"
                v-html="list.MobileReadMoreTitle ? list.MobileReadMoreTitle : link.Text"
            />
            <span class="menu-item"> ></span>
        </div>
    </div>
</template>
<script>
export default {
    name: 'MegaMenuCategoryItemList',
    props: {
        list: {
            type: Object,
            default() {
                return {};
            }
        },
        show: {
            type: Boolean,
            default() {
                return false;
            }
        },
        link: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    mounted() {
    },
    methods: {
        reset() {
            this.$emit('reset', true);
        }
    }
};
</script>
<style lang="scss" scoped>
@import '../header'
</style>
